export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-[640px] flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/50 via-background-50 to-accent-50/30"></div>
      <div className="relative w-full max-w-[1440px] mx-auto px-4 md:px-6 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-sparkling-line text-sm"></i>
              <span>免费高清 · 流畅播放</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              春夜影院 - 最新电影电视剧免费高清在线看
            </h1>

            <p className="text-base md:text-lg text-foreground-600 font-medium mb-5">
              不缓冲，蓝光画质，沉浸式观影体验
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-7">
              春夜影院提供最新电影全集与电视剧大全，涵盖电影大全、综艺节目及动漫等内容，全部支持蓝光画质免费在线看。平台每日更新热播内容，采用全球CDN加速确保流畅不缓冲播放。无论是最新院线大片还是经典电视剧大全，春夜影院都为每一位观众打造沉浸式的观影体验。
            </p>

            <div className="flex items-center justify-center lg:justify-start gap-6 md:gap-8 mb-7">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-display text-primary-600">30,000+</div>
                <div className="text-xs text-foreground-500 mt-1">影视内容</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-display text-primary-600">每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">同步上线</div>
              </div>
              <div className="w-px h-8 bg-background-300"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-display text-primary-600">全端适配</div>
                <div className="text-xs text-foreground-500 mt-1">随时随地</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a href="#ranking" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a href="#index" className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 rounded-md font-medium text-sm hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer border border-background-300/60">
                <i className="ri-compass-3-line text-lg"></i>
                浏览片库
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20cinematic%20composition%20with%20warm%20golden%20and%20crimson%20tones%2C%20movie%20theater%20atmosphere%2C%20vintage%20film%20projector%20with%20soft%20glow%2C%20rich%20dark%20shadows%2C%20artistic%20photography%2C%20classic%20cinema%20aesthetic%2C%20warm%20ambient%20lighting%2C%20no%20text%20no%20people&width=1000&height=750&seq=hero-main&orientation=portrait"
                alt="春夜影院 - 沉浸式观影体验"
                className="w-full h-auto rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}